import { createGlobalStyle } from 'styled-components';
import '../assets/fonts/fonts.css';

export const GlobalStyles = createGlobalStyle`
  :root {
    --connolly-red: #ff3E45;
    --connolly-black: #363d43;
    --connolly-grey: #f1f1f1;
    --connolly-dark-grey: #c4c4c4;
  }

  * {
    margin: 0;
    padding: 0;
  }

  #gatsby-focus-wrapper {
    height: 100%;
    width: 100%;
    position: relative;
  }

  html,
  body {
    height: 100%;
    width: 100%;
  }

  html {
    box-sizing: border-box;
    height: auto;
  }

  *, *::before, *::after {
    box-sizing: inherit;
  }

  body {
    font-family: "Open Sans", "Segoe UI", Tahoma, sans-serif;
    font-optical-sizing: auto;
    font-weight: 400;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  h1, h2, h3, h4, h5, h6 {
    font-family: Domine, serif;
  }

  p, span, em, i, b, input, input::placeholder, textarea, textarea::placeholder {
    font-family: 'Open Sans', 'Segoe UI', Tahoma, sans-serif;
  }

  h1, h2, h3, h4, h5, h6, p, span, em, i, b, ul, li {
    color: var(--connolly-black);
    font-optical-sizing: auto;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  ul {
    list-style-type: none;
    margin: 0;
    padding: 0;
  }

  .fade-in {
    opacity: 0;
  }

  .scroll-lock {
    overflow: hidden;
  }


  @supports (view-transition-name: none) {
    ::view-transition-group(cart-blob) {
      animation-duration: 0.6s;
      animation-timing-function: ease-in-out;
    }

    ::view-transition-old(cart-counter) {
      animation: toDown 0.15s cubic-bezier(0.4, 0, 1, 1) both;
    }

    ::view-transition-new(cart-counter) {
      animation: fromUp 0.15s cubic-bezier(0, 0, 0.2, 1) 0.15s both;
    }
  }

  @keyframes toDown {
    from {
      transform: translateY(0);
      opacity: 1;
    }

    to {
      transform: translateY(4px);
      opacity: 0;
    }
  }

  @keyframes fromUp {
    from {
      transform: translateY(-3px);
      opacity: 0;
    }

    to {
      transform: translateY(0);
      opacity: 1;
    }
  }

  .blob {
    aspect-ratio: 1;
    background-color: var(--connolly-red);
    border-radius: 100%;
    height: 100%;
    position: relative;
    view-transition-name: cart-blob;
    width: 100%;
  }
`;

export const defaultColors = {
  primary: '#FF3E45',
  secondary: '#363D43'
};

export const customDropdownMenuStyles = (style) => ({
  container: (provided, state) => ({
    ...provided,
    alignItems: 'center',
    background: 'transparent',
    border: state.isFocused
      ? `0.125rem solid ${defaultColors.primary}`
      : `0.063rem solid ${defaultColors.primary}`,
    borderRadius: '6px',
    color: defaultColors.secondary,
    display: 'inline-flex',
    fontFamily: "'Open Sans', 'Segoe UI', Tahoma, sans-serif",
    fontSize: style?.fontSize ?? '1rem',
    fontWeight: 'bold',
    height: style?.height || '1.625em',
    letterSpacing: '0.031em',
    marginTop: '3px',
    marginBottom: '15px',
    padding: 0,
    ...style
  }),
  control: (provided) => ({
    ...provided,
    background: 'transparent',
    border: 'none',
    boxShadow: 'none',
    padding: style?.controlPadding ?? '0 0.7325rem 0 2.25rem',
    cursor: 'pointer',
    height: '100%'
  }),
  dropdownIndicator: (provided, state) => ({
    ...provided,
    alignItems: 'center',
    backgroundColor: defaultColors.primary,
    borderRadius: '6px',
    color: '#fff',
    display: 'flex',
    height: style?.dropdownIndicator?.height ?? '26px',
    justifyContent: 'center',
    left: state.isFocused ? '-1px' : 0,
    padding: style?.dropdownIndicator?.padding ?? '6px',
    pointerEvents: 'none',
    position: 'absolute',
    width: style?.dropdownIndicator?.width ?? '26px',
    '&:hover': {
      color: '#fff'
    }
  }),
  indicatorSeparator: () => ({
    display: 'none'
  }),
  input: (provided) => ({
    ...provided,
    color: defaultColors.primary
  }),
  menu: (provided) => ({
    ...provided,
    background: '#fff',
    border: `0.143em solid ${defaultColors.primary}`,
    borderRadius: '0 0 6px 6px',
    fontFamily: "'Open Sans', 'Segoe UI', Tahoma, sans-serif",
    fontSize: '0.875rem',
    fontWeight: 'bold',
    letterSpacing: '0.071em',
    margin: 0
  }),
  noOptionsMessage: (provided) => ({
    ...provided,
    color: defaultColors.primary
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected ? `${defaultColors.primary}` : 'transparent',
    paddingLeft: '1.25rem',
    '&:hover': {
      color: '#fff',
      cursor: 'pointer',
      backgroundColor: defaultColors.primary
    }
  }),
  placeholder: (provided) => ({
    ...provided,
    fontFamily: "'Open Sans', 'Segoe UI', Tahoma, sans-serif",
    fontStyle: 'italic',
    fontWeight: 'bold',
    fontSize: '1rem',
    color: defaultColors.secondary,
    opacity: 0.65
  }),
  singleValue: (provided) => ({
    ...provided,
    color: defaultColors.secondary
  }),
  valueContainer: (provided) => ({
    ...provided,
    padding: '0'
  })
});
